<div class="board" [style]="style"
     (touchstart)="swipe($event, 'start')"
     (touchend)="swipe($event, 'end')"
     *ngIf="board && board.walls"
>
  <div class="walls">
    <div fxLayout="row" *ngIf="board.walls.length">
      <app-brick class="shadow" [brick]="board.walls[board.rows-1][board.cols-1]" [size]="bitSize"></app-brick>
      <app-brick class="shadow" *ngFor="let brick of board.walls[board.rows-1]" [brick]="brick" [size]="bitSize"></app-brick>
      <app-brick class="shadow" [brick]="board.walls[board.rows-1][0]" [size]="bitSize"></app-brick>
    </div>
    <div fxLayout="row" *ngFor="let row of board.walls">
      <app-brick class="shadow" [brick]="row[board.cols-1]" [size]="bitSize"></app-brick>
      <app-brick *ngFor="let brick of row" [brick]="brick" [size]="bitSize"></app-brick>
      <app-brick class="shadow" [brick]="row[0]" [size]="bitSize"></app-brick>
    </div>
    <div fxLayout="row" *ngIf="board.walls.length">
      <app-brick class="shadow" [brick]="board.walls[0][board.cols-1]" [size]="bitSize"></app-brick>
      <app-brick class="shadow" *ngFor="let brick of board.walls[0]" [brick]="brick" [size]="bitSize"></app-brick>
      <app-brick class="shadow" [brick]="board.walls[0][0]" [size]="bitSize"></app-brick>
    </div>
  </div>
  <app-snake *ngFor="let snake of board.snakes" [style]="snakeStyle" [bitSize]="bitSize" [snake]="snake"></app-snake>
  <app-food *ngFor="let bite of board.food" [style]="snakeStyle" [food]="bite" [size]="bitSize"></app-food>
  <div class="overlay" [style]="overlayStyle" *ngIf="board.over||board.counter||board.paused">
    <span *ngIf="board.over">Game Over</span>
    <span *ngIf="board.paused">Paused</span>
    <span *ngIf="board.counter">{{board.counter}}</span>
  </div>
</div>
